import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import React, { FC, ReactNode, memo } from 'react';
import useStyles from './styles';

type Props = {
  title?: ReactNode;
  desc?: ReactNode;
};

const PeContentLayoutIntro: FC<Props> = ({ title, desc }) => {
  const styles = useStyles({
    avatarUrl: '',
  });

  return (
    <>
      {title && (
        <PeTypography variant="h3" className={styles.registerTitle}>
          {title}
        </PeTypography>
      )}
      {desc && (
        <PeTypography variant="body1" className={styles.registerDesc}>
          {desc}
        </PeTypography>
      )}
    </>
  );
};

export default memo(PeContentLayoutIntro);
